import(/* webpackMode: "eager", webpackExports: ["default"] */ "/app/src/app/download/components/DownloadFirstScreen/index.tsx");
;
import(/* webpackMode: "eager" */ "/app/src/app/download/styles.scss");
